function SecureUserAccountConfirmation($state) {
    return {
        restrict: 'E',
        template: require('./secure-user-account-confirmation-template.html').trim(),
        scope: {},
        link(scope) {
            const redirect = $state.params.redirect || {};
            const params = redirect.params
                ? '?' + Object.entries(redirect.params).map(([key, value]) => `${key}=${value}`).join('&')
                : '';

            scope.cta = `Go to ${redirect.name || 'my profile'}`;
            scope.url = redirect.url ? `/${redirect.url}${params}` : '/my-account';
        }
    };
}

module.exports = SecureUserAccountConfirmation;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/secure-user-account/secure-user-account-confirmation-directive.js
 **/